"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4335,6321],{

/***/ 80348:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export keyToIconNameMap */
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43474);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24959);






var keyToIconNameMap = {
    BESTSELLER: "48/bestseller",
    CHARITY: "48/charity",
    CLEAN: "48/clean",
    LIMITED_EDITION: "48/limited-time",
    NEW_ARRIVAL: "48/new",
    SOLD_OUT: "48/out-of-stock"
};
var ProductGraphicLabels = function(props) {
    var className = props.className, items = props.items, limit = props.limit;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    if (limit && items.length > limit) {
        items = items.slice(0, limit);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(className, "grid grid-cols-1 gap-16"),
        children: items.map(function(key) {
            return Boolean(keyToIconNameMap[key]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                className: "mx-auto",
                name: keyToIconNameMap[key],
                "aria-label": key
            }, key);
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.memo(ProductGraphicLabels));


/***/ }),

/***/ 82775:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductPrice_ProductPrice)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/ProductPrice/messages.ts
/* harmony default export */ const messages = ({
    old: {
        en: "Price reduced from"
    },
    "new": {
        en: "On sale at"
    }
});

;// CONCATENATED MODULE: ./src/compositions/ProductPrice/ProductPrice.tsx







// TODO should we use currencyCode from data? - added on 14.01.2022 by sonatskiy
var ProductPrice = function(props) {
    var _data_discountPrice, _data_standardPrice;
    var className = props.className, data = props.data, formattedData = props.formattedData, _props_textStyle = props.textStyle, textStyle = _props_textStyle === void 0 ? "h8" : _props_textStyle, _props_oldPriceClassName = props.oldPriceClassName, oldPriceClassName = _props_oldPriceClassName === void 0 ? "font-normal" : _props_oldPriceClassName, _props_newPriceClassName = props.newPriceClassName, newPriceClassName = _props_newPriceClassName === void 0 ? "font-bold" : _props_newPriceClassName, _props_withNbsp = props.withNbsp, withNbsp = _props_withNbsp === void 0 ? true : _props_withNbsp;
    var intl = (0,useIntl/* default */.Z)();
    var discountPrice = data === null || data === void 0 ? void 0 : (_data_discountPrice = data.discountPrice) === null || _data_discountPrice === void 0 ? void 0 : _data_discountPrice.amount;
    var standardPrice = data === null || data === void 0 ? void 0 : (_data_standardPrice = data.standardPrice) === null || _data_standardPrice === void 0 ? void 0 : _data_standardPrice.amount;
    var finalPrice;
    var oldPrice;
    var oldPriceLabel;
    var newPriceLabel;
    if (formattedData) {
        var discountPrice1 = formattedData.discountPrice, standardPrice1 = formattedData.standardPrice;
        finalPrice = discountPrice1 || standardPrice1;
        if (finalPrice !== standardPrice1) {
            oldPrice = standardPrice1;
            oldPriceLabel = intl.formatMessage(messages.old);
            newPriceLabel = intl.formatMessage(messages["new"]);
        }
    } else {
        if (typeof discountPrice === "number") {
            // it's formatted as USD, not cents
            finalPrice = (0,formatPrice/* default */.Z)(discountPrice, {
                isCents: false
            });
            if (standardPrice > discountPrice) {
                oldPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                    isCents: false
                });
                oldPriceLabel = intl.formatMessage(messages.old);
                newPriceLabel = intl.formatMessage(messages["new"]);
            }
        } else if (typeof standardPrice === "number") {
            finalPrice = (0,formatPrice/* default */.Z)(standardPrice, {
                isCents: false
            });
        }
    }
    if (!finalPrice) {
        return null;
    }
    if (oldPrice) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
            className: className,
            style: textStyle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                    className: (0,clsx/* default */.Z)(oldPriceClassName),
                    "aria-label": oldPriceLabel,
                    "data-testid": "oldPrice",
                    children: oldPrice
                }),
                withNbsp && "\xa0",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                    className: (0,clsx/* default */.Z)(newPriceClassName),
                    "aria-label": newPriceLabel,
                    "data-testid": "price",
                    children: finalPrice
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
        className: (0,clsx/* default */.Z)(className, newPriceClassName),
        style: textStyle,
        "data-testid": "price",
        children: finalPrice
    });
};
/* harmony default export */ const ProductPrice_ProductPrice = (/*#__PURE__*/react.memo(ProductPrice));


/***/ }),

/***/ 93735:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ StyledTimer_StyledTimer)
});

// UNUSED EXPORTS: bgColorToClassName

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(53743);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/compositions/StyledTimer/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Deal ends in:"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx
/* eslint-disable max-len */ 








var bgColorToClassName = {
    black: "bg-black",
    white: "bg-white",
    "gray-10": "bg-gray-10",
    "light-beige": "bg-light-beige",
    "gold-30": "bg-gold-30",
    "gold-70": "bg-gold-70"
};
var baseBoxClassName = "flex items-center justify-center rounded";
var getParamsBySize = function(param) {
    var size = param.size, countdownColor = param.countdownColor, captionColor = param.captionColor, backgroundColor = param.backgroundColor, withHours = param.withHours;
    var backgroundColorClass = backgroundColor ? "bg-".concat(backgroundColor) : "bg-light-beige";
    var countdownColorClass = countdownColor ? "text-".concat(countdownColor) : "";
    var captionColorClass = captionColor ? "text-".concat(captionColor) : "";
    var className = (0,clsx/* default */.Z)(baseBoxClassName, backgroundColorClass, countdownColorClass);
    if (size === 24) {
        return {
            textStyle: "text-sh6 text-[12rem]",
            format: "\n        ".concat(withHours ? '[<div class="mr-8"><div class="w-s24 h-s24 '.concat(className, '">] HH [</div><div class="').concat(captionColorClass, ' text-t8">hours</div></div><div class="').concat(captionColorClass, '">:</div>]') : "", '\n        [<div class="mr-8 ').concat(withHours ? "ml-8" : "", '"><div class="w-s24 h-s24 ').concat(className, '">] mm [</div><div class="').concat(captionColorClass, ' text-t8">minutes</div></div><div class="').concat(captionColorClass, '">:</div>]\n        [<div class="ml-8"><div class="w-s24 h-s24 ').concat(className, '">] ss [</div><div class="').concat(captionColorClass, ' text-t8">seconds</div></div>]\n      ')
        };
    }
    if (size === 36) {
        return {
            textStyle: "text-sh6",
            format: "\n        ".concat(withHours ? '[<div class="mr-8"><div class="w-s36 h-s36 '.concat(className, '">] HH [</div><div class="').concat(captionColorClass, ' text-t3">hours</div></div><div class="').concat(captionColorClass, '">:</div>]') : "", '\n        [<div class="mr-8 ').concat(withHours ? "ml-8" : "", '"><div class="w-s36 h-s36 ').concat(className, '">] mm [</div><div class="').concat(captionColorClass, ' text-t3">minutes</div></div><div class="').concat(captionColorClass, '">:</div>]\n        [<div class="ml-8"><div class="w-s36 h-s36 ').concat(className, '">] ss [</div><div class="').concat(captionColorClass, ' text-t3">seconds</div></div>]\n      ')
        };
    }
    if (size === 56) {
        return {
            textStyle: "text-sh3",
            format: "\n        ".concat(withHours ? '[<div class="mr-8"><div class="w-s56 h-s56 '.concat(className, '">] HH [</div><div class="mt-4 ').concat(captionColorClass, ' text-p5">hours</div></div><div class="').concat(captionColorClass, '">:</div>]') : "", '\n        [<div class="mr-8 ').concat(withHours ? "ml-8" : "", '"><div class="w-s56 h-s56 ').concat(className, '">] mm [</div><div class="mt-4 ').concat(captionColorClass, ' text-p5">minutes</div></div><div class="').concat(captionColorClass, '">:</div>]\n        [<div class="ml-8"><div class="w-s56 h-s56 ').concat(className, '">] ss [</div><div class="mt-4 ').concat(captionColorClass, ' text-p5">seconds</div></div>]\n      ')
        };
    }
};
var StyledTimer = function(props) {
    var className = props.className, initialTime = props.initialTime, backgroundColor = props.backgroundColor, countdownColor = props.countdownColor, captionColor = props.captionColor, customTitleClassname = props.titleClassname, customTitleColor = props.titleColor, customTitleStyle = props.titleStyle, withHours = props.withHours, withTitle = props.withTitle, _props_size = props.size, size = _props_size === void 0 ? 56 : _props_size, _props_cookieName = props.cookieName, cookieName = _props_cookieName === void 0 ? constants/* default */.Z.cookieNames.rootCountdown : _props_cookieName, showExpiredTimer = props.showExpiredTimer, dataTestId = props["data-testid"], onExpired = props.onExpired;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var countdownRef = (0,react.useRef)();
    var _getParamsBySize = getParamsBySize({
        size: size,
        countdownColor: countdownColor,
        captionColor: captionColor,
        backgroundColor: backgroundColor,
        withHours: withHours
    }), format = _getParamsBySize.format, textStyle = _getParamsBySize.textStyle;
    var _useCountdown = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName: cookieName,
        initialTime: initialTime,
        format: format,
        message: messages.time
    }), countdownMessage = _useCountdown.countdownMessage, isExpired = _useCountdown.isExpired;
    (0,react.useEffect)(function() {
        if (isExpired && typeof onExpired === "function") {
            onExpired();
        }
    }, [
        isExpired,
        onExpired
    ]);
    var titleClassname = isMobile ? "mb-12" : "mb-24";
    var titleColor = isMobile ? "white" : "gold-70";
    var titleStyle = isMobile ? "t1" : "sh3";
    if (isExpired && !showExpiredTimer) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            withTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: customTitleClassname !== null && customTitleClassname !== void 0 ? customTitleClassname : titleClassname,
                message: messages.title,
                style: customTitleStyle !== null && customTitleStyle !== void 0 ? customTitleStyle : titleStyle,
                color: customTitleColor !== null && customTitleColor !== void 0 ? customTitleColor : titleColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("inline-flex items-baseline text-center", textStyle),
                ref: countdownRef,
                dangerouslySetInnerHTML: {
                    __html: countdownMessage
                },
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const StyledTimer_StyledTimer = (/*#__PURE__*/react.memo(StyledTimer));


/***/ }),

/***/ 30248:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeroBase_HeroBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx + 1 modules
var HeroMediaBlock = __webpack_require__(68155);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
;// CONCATENATED MODULE: ./src/compositions/banners/HeroBase/images/desktop-bg.jpg
const desktop_bg_namespaceObject = __webpack_require__.p + "images/desktop-bg_f6e53d.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/HeroBase/images/mobile-bg.jpg
const mobile_bg_namespaceObject = __webpack_require__.p + "images/mobile-bg_6309e7.jpg";
;// CONCATENATED MODULE: ./src/compositions/banners/HeroBase/HeroBase.tsx






// TODO After the home page is ready and all banners are added, we will need to decide whether we need a default image for desktop and mobile - added on 2021-12-30 by vkudla


var HeroBase = function(props) {
    var className = props.className, title = props.title, text = props.text, greeting = props.greeting, mobileImage = props.mobileImage, desktopImage = props.desktopImage, button = props.button, _props_isFetching = props.isFetching, isFetching = _props_isFetching === void 0 ? false : _props_isFetching, _props_desktopContentAtTop = props.desktopContentAtTop, desktopContentAtTop = _props_desktopContentAtTop === void 0 ? false : _props_desktopContentAtTop, wideMT = props.wideMT, wideMB = props.wideMB, children = props.children, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "heroBanner" : tmp;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    if (isMobile) {
        var mobileImageSrc = mobileImage || mobile_bg_namespaceObject;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
            className: className,
            "data-testid": dataTestId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                    src: mobileImageSrc,
                    height: 320
                }),
                !isFetching && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-black px-24 pb-32 pt-24 text-white",
                    children: [
                        Boolean(greeting) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mb-8",
                            message: greeting,
                            style: "eye2",
                            color: "gold-30"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: title,
                            style: "h4",
                            html: true
                        }),
                        Boolean(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-8",
                            message: text,
                            style: "p1",
                            html: true
                        }),
                        children,
                        /*#__PURE__*/ react.cloneElement(button, {
                            className: "mt-16",
                            style: "gold-30",
                            fullWidthOnMobile: true
                        })
                    ]
                })
            ]
        });
    }
    var desktopImageSrc = desktopImage || desktop_bg_namespaceObject;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, "relative"),
        wideMT: wideMT,
        wideMB: wideMB,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMediaBlock/* default */.Z.Image, {
                src: desktopImageSrc,
                height: 544
            }),
            !isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(WidthContainer/* default */.Z, {
                className: (0,clsx/* default */.Z)("absolute inset-0 flex h-full py-56", desktopContentAtTop ? "items-start" : "items-center"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-464",
                    children: [
                        Boolean(greeting) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mb-24",
                            message: greeting,
                            style: "eye2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: title,
                            style: "h3",
                            html: true
                        }),
                        Boolean(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: text,
                            style: "p1",
                            html: true
                        }),
                        children,
                        /*#__PURE__*/ react.cloneElement(button, {
                            className: "mt-24",
                            style: "primary"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const HeroBase_HeroBase = (/*#__PURE__*/react.memo(HeroBase));


/***/ }),

/***/ 27344:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79006);
/* harmony import */ var core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56376);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24113);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31627);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44946);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85808);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var QuoteBlock = function(props) {
    var className = props.className, supTitle = props.supTitle, text = props.text, richText = props.richText, _props_textStyle = props.textStyle, textStyle = _props_textStyle === void 0 ? "sh1" : _props_textStyle, authorName = props.authorName, authorPosition = props.authorPosition, authorImage = props.authorImage;
    var intl = (0,intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var isRichText = "richText" in props;
    var quotedText = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return isRichText ? null : "“".concat(intl.formatMessage(text).trim(), "”");
    }, [
        text,
        intl,
        isRichText
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: "mx-auto max-w-752 border-y border-solid border-gold-50 py-24 text-center",
            children: [
                Boolean(supTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: "mb-24",
                    message: supTitle,
                    style: "eye2",
                    color: "gold-70"
                }),
                isRichText ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    className: "mx-auto max-w-[688rem]",
                    message: richText
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    className: "mx-auto max-w-[688rem]",
                    message: quotedText,
                    style: textStyle
                }),
                Boolean(authorName) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    className: "mt-48",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                            message: authorName,
                            style: "sh5",
                            color: "gold-50"
                        }),
                        Boolean(authorPosition) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                            className: "mt-4",
                            message: authorPosition,
                            style: "p2"
                        })
                    ]
                }),
                Boolean(authorImage) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, authorImage), {
                    className: (0,classnames__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(authorImage.className, "mt-48")
                }))
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuoteBlock);


/***/ }),

/***/ 6658:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66226);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69541);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7138);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23796);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21182);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SubscribeButton = function(props) {
    var className = props.className, title = props.title, _props_style = props.style, style = _props_style === void 0 ? "primary" : _props_style, _props_size = props.size, size = _props_size === void 0 ? 56 : _props_size, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, placement = props.placement, loading = props.loading, tmp = props["data-testid"], dataTestId = tmp === void 0 ? "subscribeButton" : tmp, onClick = props.onClick;
    var _useSubscribeOffer = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscribeOffer */ .Hu)(), offerType = _useSubscribeOffer.offerType, formattedPrice = _useSubscribeOffer.formattedPrice, formattedPriceWithDiscount = _useSubscribeOffer.formattedPriceWithDiscount, formattedExtraShippingPrice = _useSubscribeOffer.formattedExtraShippingPrice, eventDiscountText = _useSubscribeOffer.eventDiscountText, coupon = _useSubscribeOffer.couponCode, isFetching = _useSubscribeOffer.isFetching, handleSubscribeClick = _useSubscribeOffer.handleSubscribeClick;
    var freeTrialPrice = offerType === "freeTrial" ? formattedExtraShippingPrice : null;
    var price = freeTrialPrice || formattedPriceWithDiscount || formattedPrice;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: className,
        title: title || _object_spread_props(_object_spread({}, components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.subscribeForPrice), {
            values: {
                price: price
            }
        }),
        size: size,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        loading: isFetching || loading,
        to: links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.subscribe,
        onClick: function(event) {
            (0,analytics__WEBPACK_IMPORTED_MODULE_6__/* .track */ .j)("Banner click", {
                placement: placement,
                content: "Subscribe",
                action: "link",
                link: links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.subscribe,
                discount: eventDiscountText,
                coupon: coupon
            });
            handleSubscribeClick();
            if (typeof onClick === "function") {
                onClick(event);
            }
        },
        "data-testid": dataTestId,
        html: true
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SubscribeButton);


/***/ }),

/***/ 36122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   X: () => (/* binding */ useProductsInQueueContext),
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83464);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52983);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55222);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50556);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17382);
/* harmony import */ var modules_queue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11982);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}









var ProductsInQueueContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.createContext)(null);
var useProductsInQueueContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(ProductsInQueueContext);
};
var ProductsInQueueProvider = function(param) {
    var children = param.children;
    var _user_analyticsMetadata;
    var user = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .a)().user;
    var productsInQueueQty = (user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.productsInQueueQty) || 0;
    var countInQueueRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    countInQueueRef.current = productsInQueueQty;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(productsInQueueQty), 2), count = _useState[0], setCount = _useState[1];
    var _useState1 = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), 2), queueItems = _useState1[0], setQueueItems = _useState1[1];
    var updateCount = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var postponedItems = (0,modules_queue__WEBPACK_IMPORTED_MODULE_6__/* .getPostponedItems */ .p8)();
        var highPriorityProducts = local_storage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.localStorageNames.queueHighPriorityProducts);
        var lowPriorityProducts = local_storage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z.localStorageNames.queueLowPriorityProducts);
        var postponedProductsCount = [].concat(highPriorityProducts, postponedItems, lowPriorityProducts).filter(Boolean).length;
        var finalCount = countInQueueRef.current + postponedProductsCount;
        setCount(finalCount);
        setQueueItems(postponedItems);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        updateCount();
    }, [
        productsInQueueQty,
        updateCount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ProductsInQueueContext.Provider, {
        value: {
            queueItems: queueItems,
            count: count,
            updateCount: updateCount
        },
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductsInQueueProvider);


/***/ }),

/***/ 34554:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ LandingPage_LandingPage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/hooks/useLandingSetup.ts
var useLandingSetup = __webpack_require__(69201);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-helmet-async@2.0.4_react-dom@18.2.0_react@18.2.0/node_modules/react-helmet-async/lib/index.esm.js
var index_esm = __webpack_require__(75479);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/compositions/PageSkeleton/PageSkeleton.tsx
var PageSkeleton = __webpack_require__(69886);
// EXTERNAL MODULE: ./src/pages/landing/View/View.tsx
var View = __webpack_require__(99812);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(73281);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/hooks/useFlow.ts
var useFlow = __webpack_require__(19564);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/getters/getCouponFromQueryParams.ts
var getCouponFromQueryParams = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/getForcedCouponByPathname.ts



var getForcedCouponByPathname = function(pathname) {
    // /men/free-trial -> /free-trial
    var genderLessPathName = pathname.replace("/men", "");
    if (genderLessPathName === links/* default */.ZP.freeTrial || genderLessPathName === links/* default */.ZP.freeTrialCa) {
        return "FREE_TRIAL";
    }
    if (pathname === links/* default */.ZP.freePerfume) {
        return "SUBFREEPRODUCT";
    }
    if (pathname === links/* default */.ZP.secondMonthFree) {
        return "2ND_MTH_FREE_8FE998";
    }
    if (pathname === links/* default */.ZP.nift) {
        return "HD60";
    }
    if (pathname === links/* default */.ZP.bouqs) {
        return "HD60";
    }
    if (pathname === links/* default */.ZP.andreDrummond) {
        return "HD50";
    }
};
/* harmony default export */ const util_getForcedCouponByPathname = (getForcedCouponByPathname);

;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/useLandingCouponCode.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}









var useLandingCouponCode = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 1), _useSearchParams_ = _useSearchParams[0], queryCoupon = _useSearchParams_.cpn, utmCampaign = _useSearchParams_.utm_campaign;
    var isDefaultCoupon50Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.defaultCoupon50);
    var isHoliday22Sub60Enabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.holiday22Sub60);
    var isPlanSelectionInPaymentEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.paymentPlanSelection) === "b";
    var isCanada = pathname === links/* default */.ZP.freeTrialCa || pathname === links/* default */.ZP.freeTrialMenCa || Boolean(utmCampaign === null || utmCampaign === void 0 ? void 0 : utmCampaign.match(/canada/i));
    var isInfluencerFlow = (0,useFlow/* default */.Z)().isInfluencerFlow;
    var couponCode = util_getForcedCouponByPathname(pathname);
    if (!couponCode && queryCoupon) {
        couponCode = (0,getCouponFromQueryParams/* default */.ZP)(queryCoupon, isPlanSelectionInPaymentEnabled);
    }
    var cookieCouponCode = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.discountCoupon);
    // queryCoupon may be null for 'none' param and undefined in case of invalid param
    if (couponCode === undefined) {
        if (cookieCouponCode !== undefined) {
            couponCode = cookieCouponCode;
        } else if (isInfluencerFlow) {
            couponCode = "HDR55INF";
        } else if (isCanada) {
            couponCode = "HD60CA";
        } else if (isHoliday22Sub60Enabled) {
            couponCode = "HD60";
        } else if (isDefaultCoupon50Enabled) {
            couponCode = isPlanSelectionInPaymentEnabled ? "HD50CRO" : "HD50";
        } else {
            couponCode = isPlanSelectionInPaymentEnabled ? "HD25CRO" : "HD25";
        }
    }
    var country = isCanada ? "CA" : "US";
    return {
        couponCode: couponCode,
        country: country
    };
};
/* harmony default export */ const util_useLandingCouponCode = (useLandingCouponCode);

// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/bouqsLogo.png
const bouqsLogo_namespaceObject = __webpack_require__.p + "images/bouqsLogo_4859d6.png";
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-mobile.jpg
const andre_drummond_hero_mobile_namespaceObject = __webpack_require__.p + "images/andre-drummond-hero-mobile_b1268f.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-mobile.jpg?src-loader&size

/* harmony default export */ const andre_drummond_hero_mobilesrc_loader_size = ({ src: andre_drummond_hero_mobile_namespaceObject, aspect: 0.6135693215339233, width: 1248, height: 2034 });
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-desktop.jpg
const andre_drummond_hero_desktop_namespaceObject = __webpack_require__.p + "images/andre-drummond-hero-desktop_7d9f35.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-desktop.jpg?src-loader&size

/* harmony default export */ const andre_drummond_hero_desktopsrc_loader_size = ({ src: andre_drummond_hero_desktop_namespaceObject, aspect: 1.875, width: 2880, height: 1536 });
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-with-case-mobile.jpg
const andre_drummond_hero_with_case_mobile_namespaceObject = __webpack_require__.p + "images/andre-drummond-hero-with-case-mobile_3908e8.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-with-case-mobile.jpg?src-loader&size

/* harmony default export */ const andre_drummond_hero_with_case_mobilesrc_loader_size = ({ src: andre_drummond_hero_with_case_mobile_namespaceObject, aspect: 0.6135693215339233, width: 1248, height: 2034 });
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-with-case-desktop.jpg
const andre_drummond_hero_with_case_desktop_namespaceObject = __webpack_require__.p + "images/andre-drummond-hero-with-case-desktop_23b9c8.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/images/andre-drummond-hero-with-case-desktop.jpg?src-loader&size

/* harmony default export */ const andre_drummond_hero_with_case_desktopsrc_loader_size = ({ src: andre_drummond_hero_with_case_desktop_namespaceObject, aspect: 1.875, width: 2880, height: 1536 });
;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/messages.ts
/* harmony default export */ const messages = ({
    nift: {
        title: {
            en: 'Get your first month<br class="onlyMobile"/> for less than $7'
        },
        text: {
            // eslint-disable-next-line max-len
            en: "Use your <strong>$30</strong> Nift gift certificate to score a new designer scent (<strong>{price}</strong>), travel case (<strong>$15.95</strong>), and shipping (<strong>$3.99</strong>) for just <strong>{priceWithDiscount}</strong>. And if you love Scentbird, indulge in new designer scents every month after for just <strong>{price}</strong> per month."
        },
        note: {
            en: 'You may update your preferences or cancel<br class="onlyMobile"/> at any time.'
        }
    },
    bouqs: {
        title: {
            en: "Get 60% off and a free case"
        },
        text: {
            en: "Get your first month for less than <strong>$7</strong> courtesy of Bouqs. Indulge in new designer scents every month after for just <strong>{price}</strong>."
        },
        note: {
            en: "Upgrade or cancel at any time.  Deal ends in:"
        }
    },
    andreDrummond: {
        title: {
            en: '\n        Get 50% off<br /> and a free<br class="onlyDesktop"/> case\n      '
        },
        text: {
            en: '\n        Step up your fragrance game like a<br class="onlyDesktop" /> pro with<br class="onlyMobile" />\n        new designer scents every<br class="onlyDesktop" /> month after<br class="onlyMobile" /> for just {price}.<br class="onlyDesktop" />\n        <span class="{afterTextStyle}">Get your first month for {priceWithDiscount}.</span>\n      '
        },
        note: {
            en: "Deal ends in:"
        },
        button: {
            en: "Try first month for {price}"
        },
        shortButton: {
            en: "Try for {price}"
        },
        buttonWithDiscount: {
            en: "Try first month for {priceWithDiscount} <s>{price}</s>"
        },
        productsBlockTitle: {
            en: '\n        Select what you\'d<br class="onlyMobile" /> like to try<br class="onlyDesktop" /> from andre drummond’s<br class="onlyMobile" /> pro picks\n      '
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/useLandingCustomHeroBlocks.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var getCustomBlocksByPathname = function(props) {
    var pathname = props.pathname, isMobile = props.isMobile, price = props.price, priceWithDiscount = props.priceWithDiscount, offerType = props.offerType;
    if (pathname === links/* default */.ZP.nift) {
        return {
            title: {
                message: messages.nift.title,
                style: isMobile ? "h4" : "h2"
            },
            text: {
                message: messages.nift.text,
                style: isMobile ? "p2" : "sh4"
            },
            note: {
                message: messages.nift.note,
                style: isMobile ? "p2" : "sh6"
            }
        };
    }
    if (pathname === links/* default */.ZP.bouqs) {
        return {
            title: {
                message: messages.bouqs.title,
                style: isMobile ? "h4" : "h2"
            },
            text: {
                message: messages.bouqs.text,
                style: isMobile ? "p2" : "sh4"
            },
            note: {
                message: messages.bouqs.note,
                style: isMobile ? "p2" : "sh6"
            },
            timer: {
                withLabel: false
            },
            logo: bouqsLogo_namespaceObject
        };
    }
    if (pathname === links/* default */.ZP.andreDrummond) {
        var buttonMessage = priceWithDiscount ? messages.andreDrummond.buttonWithDiscount : messages.andreDrummond.button;
        return {
            title: {
                message: messages.andreDrummond.title,
                style: isMobile ? "h4" : "h2",
                color: "gold-30"
            },
            text: {
                className: isMobile ? "mt-8" : "mt-24 max-w-464 font-normal",
                message: _object_spread_props(_object_spread({}, messages.andreDrummond.text), {
                    values: {
                        price: price,
                        priceWithDiscount: priceWithDiscount,
                        afterTextStyle: priceWithDiscount ? !isMobile && "font-bold" : "hidden"
                    }
                }),
                style: isMobile ? "p2" : "sh3",
                color: "white"
            },
            timer: {
                withLabel: true,
                titleColor: "gold-30",
                captionColor: "gold-30",
                backgroundColor: "gold-70",
                countdownColor: "white"
            },
            button: {
                style: "gold-30",
                actionType: "quiz",
                title: _object_spread_props(_object_spread({}, buttonMessage), {
                    values: {
                        price: price,
                        priceWithDiscount: priceWithDiscount
                    }
                })
            },
            background: offerType ? isMobile ? andre_drummond_hero_with_case_mobilesrc_loader_size : andre_drummond_hero_with_case_desktopsrc_loader_size : isMobile ? andre_drummond_hero_mobilesrc_loader_size : andre_drummond_hero_desktopsrc_loader_size
        };
    }
    return null;
};
var useLandingCustomHeroBlocks = function(props) {
    var pathname = (0,contexts/* usePathname */.jD)();
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return getCustomBlocksByPathname(_object_spread({
        pathname: pathname,
        isMobile: isMobile
    }, props));
};
/* harmony default export */ const util_useLandingCustomHeroBlocks = (useLandingCustomHeroBlocks);

;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/useLandingCustomProductsBlock.ts



var getCustomProductsBlockByPathname = function(pathname) {
    if (pathname === links/* default */.ZP.andreDrummond) {
        return {
            title: messages.andreDrummond.productsBlockTitle,
            slugs: [
                "2795",
                "3026",
                "2386",
                "943571",
                "872"
            ]
        };
    }
    return null;
};
var useLandingCustomProductsBlock = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    return getCustomProductsBlockByPathname(pathname);
};
/* harmony default export */ const util_useLandingCustomProductsBlock = (useLandingCustomProductsBlock);

;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/util/useLandingCustomButtons.ts
function useLandingCustomButtons_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useLandingCustomButtons_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useLandingCustomButtons_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useLandingCustomButtons_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useLandingCustomButtons_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useLandingCustomButtons_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var getCustomButtonsByPathname = function(param) {
    var pathname = param.pathname, price = param.price, priceWithDiscount = param.priceWithDiscount;
    if (pathname === links/* default */.ZP.andreDrummond) {
        return {
            brandsQuality: {
                actionType: "quiz",
                title: useLandingCustomButtons_object_spread_props(useLandingCustomButtons_object_spread({}, messages.andreDrummond.button), {
                    values: {
                        price: priceWithDiscount || price
                    }
                })
            },
            bottomBanner: {
                actionType: "quiz",
                title: useLandingCustomButtons_object_spread_props(useLandingCustomButtons_object_spread({}, messages.andreDrummond.button), {
                    values: {
                        price: priceWithDiscount || price
                    }
                })
            },
            stickyBar: {
                actionType: "subscribe",
                title: useLandingCustomButtons_object_spread_props(useLandingCustomButtons_object_spread({}, messages.andreDrummond.shortButton), {
                    values: {
                        price: priceWithDiscount || price
                    }
                })
            }
        };
    }
    return null;
};
var useLandingCustomButtons = function(props) {
    var pathname = (0,contexts/* usePathname */.jD)();
    return getCustomButtonsByPathname(useLandingCustomButtons_object_spread({
        pathname: pathname
    }, props));
};
/* harmony default export */ const util_useLandingCustomButtons = (useLandingCustomButtons);

;// CONCATENATED MODULE: ./src/pages/landing/LandingPage/LandingPage.tsx













var LandingPage = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useLandingCouponCode = util_useLandingCouponCode(), couponCode = _useLandingCouponCode.couponCode, country = _useLandingCouponCode.country;
    var canonicalPath = /men\//.test(pathname) ? links/* default */.ZP.homeMen : links/* default */.ZP.home;
    var _useLandingSetup = (0,useLandingSetup/* default */.Z)({
        couponCode: couponCode,
        country: country
    }), offerType = _useLandingSetup.offerType, eventDiscountText = _useLandingSetup.eventDiscountText, formattedPrice = _useLandingSetup.formattedPrice, formattedPriceWithDiscount = _useLandingSetup.formattedPriceWithDiscount, discountAmount = _useLandingSetup.discountAmount, discountPercent = _useLandingSetup.discountPercent, formattedExtraShippingPrice = _useLandingSetup.formattedExtraShippingPrice, isFetching = _useLandingSetup.isFetching;
    var customHeroBlocks = util_useLandingCustomHeroBlocks({
        offerType: offerType,
        price: formattedPrice,
        priceWithDiscount: formattedPriceWithDiscount
    });
    var customProductsBlock = util_useLandingCustomProductsBlock();
    var customBlocksButtons = util_useLandingCustomButtons({
        price: formattedPrice,
        priceWithDiscount: formattedPriceWithDiscount
    });
    (0,react.useEffect)(function() {
        if (!eventDiscountText) {
            return;
        }
        (0,analytics/* track */.j)("Home page", {
            discount: eventDiscountText,
            coupon: couponCode
        });
    }, [
        eventDiscountText
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSkeleton/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Helmet */.ql, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: "https://www.scentbird.com".concat(canonicalPath)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(View/* default */.Z, {
                eventDiscountText: eventDiscountText,
                offerType: offerType,
                price: formattedPrice,
                priceWithDiscount: formattedPriceWithDiscount,
                extraShippingPrice: formattedExtraShippingPrice,
                discount: discountAmount || discountPercent,
                couponCode: couponCode,
                heroCustomBlocks: customHeroBlocks,
                customProductsBlock: customProductsBlock,
                customBlocksButtons: customBlocksButtons,
                isFetching: isFetching
            })
        ]
    });
};
/* harmony default export */ const LandingPage_LandingPage = (LandingPage);


/***/ }),

/***/ 99812:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73281);
/* harmony import */ var core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17376);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52983);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42209);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99214);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47361);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84584);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69541);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51827);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50556);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98716);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66226);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10430);
/* harmony import */ var containers_ProductsInQueueProvider_ProductsInQueueProvider__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36122);
/* harmony import */ var compositions_landings_ContinueStickyBar_ContinueStickyBar__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(85201);
/* harmony import */ var compositions_buttons_SubscribeButton_SubscribeButton__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(6658);
/* harmony import */ var _components_HeroSection_HeroSection__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51564);
/* harmony import */ var _components_BrandsRow_BrandsRow__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31183);
/* harmony import */ var _components_BrandsSection_BrandsSection__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85852);
/* harmony import */ var _components_PressSection_PressSection__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(73951);
/* harmony import */ var _components_QuizSection_QuizSection__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(72757);
/* harmony import */ var _components_BottomBanner_BottomBanner__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(6088);
/* harmony import */ var _components_ProductsSection_ProductsSection__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(48266);
/* harmony import */ var _messages__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33748);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


























var HowItWorksSectionAb = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "components-HowItWorksSectionAb-HowItWorksSectionAb";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | components-HowItWorksSectionAb-HowItWorksSectionAb */ 1655).then(__webpack_require__.bind(__webpack_require__, 36675));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(36675);
        }
        return eval("require.resolve")("./components/HowItWorksSectionAb/HowItWorksSectionAb");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: "bg-light-beige",
        pw: 100,
        h: 656
    })
});
var HowItWorksSection = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "components-HowItWorksSection-HowItWorksSection";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | components-HowItWorksSection-HowItWorksSection */[__webpack_require__.e(6556), __webpack_require__.e(4483), __webpack_require__.e(3272)]).then(__webpack_require__.bind(__webpack_require__, 75749));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(75749);
        }
        return eval("require.resolve")("./components/HowItWorksSection/HowItWorksSection");
    }
}, {
    fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        className: "bg-light-beige",
        pw: 100,
        h: 656
    })
});
var View = function(props) {
    var couponCode = props.couponCode, discount = props.discount, eventDiscountText = props.eventDiscountText, extraShippingPrice = props.extraShippingPrice, isFetching = props.isFetching, offerType = props.offerType, price = props.price, priceWithDiscount = props.priceWithDiscount, heroCustomBlocks = props.heroCustomBlocks, customBlocksButtons = props.customBlocksButtons, customProductsBlock = props.customProductsBlock, offerBadge = props.offerBadge, subscribeButton = props.subscribeButton, fetchMoreButtonTitle = props.fetchMoreButtonTitle;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().isMobile;
    var defaultSectionMargin = isMobile ? "mt-64" : "mt-80";
    var pathname = (0,router__WEBPACK_IMPORTED_MODULE_9__/* .usePathname */ .jD)();
    var _useSearchParams = _sliced_to_array((0,router__WEBPACK_IMPORTED_MODULE_9__/* .useSearchParams */ .lr)(), 1), _useSearchParams_ = _useSearchParams[0], utmCampaign = _useSearchParams_.utm_campaign;
    var isHomePage = pathname === links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.home || pathname === links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.homeMen;
    var isTimerEnabled = isHomePage || Boolean(heroCustomBlocks === null || heroCustomBlocks === void 0 ? void 0 : heroCustomBlocks.timer);
    var isCanada = pathname === links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrialCa || pathname === links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrialMenCa || Boolean(utmCampaign === null || utmCampaign === void 0 ? void 0 : utmCampaign.match(/canada/i));
    var isStartButtonWithPriceEnabled = offerType === "discount" && isHomePage && !isCanada;
    var isStickyCtaWithQueueEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.abTests.homeStickyCtaWithQueue) === "b";
    var isNewHowItWorksEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z.abTests.homeNewHowItWorks) === "b";
    // TODO: Remove this tracking when CRO-189 is over
    var howItWorksRef = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        (0,analytics__WEBPACK_IMPORTED_MODULE_14__/* .track */ .j)("Home case banner display");
    });
    // narrow rootMargin to tiny line to hide StickyBar before global footer
    var _useEntry = _sliced_to_array((0,intersection_observer__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        observerProps: {
            rootMargin: "0% 0% -90%"
        }
    }), 2), stickyBarAreaRef = _useEntry[0], stickyBarAreaEntry = _useEntry[1];
    var isStickyBarVisible = stickyBarAreaEntry === null || stickyBarAreaEntry === void 0 ? void 0 : stickyBarAreaEntry.isIntersecting;
    var startButtonWithPriceMessage = _object_spread_props(_object_spread({}, _messages__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.getStartedForPrice), {
        values: {
            price: priceWithDiscount
        }
    });
    var startButtonWithCrossedPriceMessage = _object_spread_props(_object_spread({}, _messages__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.getStartedForOriginalPriceCrossed), {
        values: {
            price: price,
            priceWithDiscount: priceWithDiscount
        }
    });
    var startButtonWithCrossedPriceGoldMessage = _object_spread_props(_object_spread({}, _messages__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z.getStartedForPriceCrossedGold), {
        values: {
            price: price,
            priceWithDiscount: priceWithDiscount
        }
    });
    var heroStartButtonMessage = isNewHowItWorksEnabled ? startButtonWithCrossedPriceGoldMessage : startButtonWithCrossedPriceMessage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_ProductsInQueueProvider_ProductsInQueueProvider__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_HeroSection_HeroSection__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                isFetching: isFetching,
                offerType: offerType,
                discount: discount,
                price: price,
                priceWithDiscount: priceWithDiscount,
                extraShippingPrice: extraShippingPrice,
                customBlocks: heroCustomBlocks,
                isTimerEnabled: isTimerEnabled,
                startButtonMessage: isStartButtonWithPriceEnabled ? heroStartButtonMessage : undefined,
                offerBadge: offerBadge
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_BrandsRow_BrandsRow__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: defaultSectionMargin,
                ref: howItWorksRef
            }),
            isNewHowItWorksEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HowItWorksSectionAb, {
                startButtonMessage: isStartButtonWithPriceEnabled ? startButtonWithCrossedPriceGoldMessage : undefined
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(HowItWorksSection, {
                startButtonMessage: isStartButtonWithPriceEnabled && isMobile ? startButtonWithPriceMessage : undefined,
                showStartButton: !subscribeButton
            }),
            Boolean(subscribeButton) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                className: "mt-32 text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(compositions_buttons_SubscribeButton_SubscribeButton__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, _object_spread({}, subscribeButton))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_BrandsSection_BrandsSection__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                className: isMobile ? isNewHowItWorksEnabled ? null : "mt-72" : "mt-80",
                customButton: customBlocksButtons === null || customBlocksButtons === void 0 ? void 0 : customBlocksButtons.brandsQuality
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_QuizSection_QuizSection__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                className: isMobile ? null : defaultSectionMargin
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_PressSection_PressSection__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                className: defaultSectionMargin
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
                ref: stickyBarAreaRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_ProductsSection_ProductsSection__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                    className: defaultSectionMargin,
                    customProducts: customProductsBlock,
                    fetchMoreButtonTitle: fetchMoreButtonTitle,
                    fetchMoreButtonStyle: subscribeButton ? "primary" : undefined
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_BottomBanner_BottomBanner__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                className: defaultSectionMargin,
                customButton: customBlocksButtons === null || customBlocksButtons === void 0 ? void 0 : customBlocksButtons.bottomBanner
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(compositions_landings_ContinueStickyBar_ContinueStickyBar__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                isVisible: isStickyBarVisible,
                eventDiscountText: eventDiscountText,
                customButton: customBlocksButtons === null || customBlocksButtons === void 0 ? void 0 : customBlocksButtons.stickyBar,
                coupon: couponCode,
                continueButtonMessage: isStickyCtaWithQueueEnabled && isStartButtonWithPriceEnabled ? startButtonWithPriceMessage : undefined
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (View);


/***/ }),

/***/ 6088:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ components_BottomBanner_BottomBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/compositions/landings/BottomBanner/BottomBanner.tsx + 3 modules
var BottomBanner = __webpack_require__(35303);
// EXTERNAL MODULE: ./src/compositions/buttons/SubscribeButton/SubscribeButton.tsx
var SubscribeButton = __webpack_require__(6658);
// EXTERNAL MODULE: ./src/pages/landing/View/components/GetStartedButton/GetStartedButton.tsx + 1 modules
var GetStartedButton = __webpack_require__(86527);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BottomBanner/messages.ts
/* harmony default export */ const messages = ({
    buttonTitle: {
        en: "Create your account"
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/BottomBanner/BottomBanner.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var BottomBanner_BottomBanner = function(props) {
    var className = props.className, startButtonMessage = props.startButtonMessage, customButton = props.customButton;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var button;
    if (customButton) {
        var ButtonComponent = (customButton === null || customButton === void 0 ? void 0 : customButton.actionType) === "subscribe" ? SubscribeButton/* default */.Z : GetStartedButton/* default */.Z;
        var buttonProps = _object_spread({
            title: startButtonMessage,
            style: "gold-30",
            size: 56,
            fullWidth: true
        }, customButton);
        button = /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, _object_spread_props(_object_spread({}, buttonProps), {
            placement: "Page bottom"
        }));
    } else {
        button = isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStartedButton/* default */.Z, {
            title: startButtonMessage,
            style: "gold-30",
            fullWidth: true,
            placement: "Page bottom"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            title: startButtonMessage || messages.buttonTitle,
            to: links/* default */.ZP.subscribe,
            size: 56,
            width: 320,
            onClick: function() {
                (0,analytics/* track */.j)("Banner click", {
                    placement: "Page bottom",
                    content: "Subscribe",
                    action: "link",
                    link: links/* default */.ZP.subscribe
                });
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomBanner/* default */.Z, {
        className: className,
        button: button
    });
};
/* harmony default export */ const components_BottomBanner_BottomBanner = (BottomBanner_BottomBanner);


/***/ }),

/***/ 31183:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BrandsRow_BrandsRow)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/hooks/useScrollingFrame.ts
var useScrollingFrame = __webpack_require__(6163);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(99214);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/messages.ts
/* harmony default export */ const messages = ({
    text: {
        en: "And many more luxury brands to choose from."
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/images/brands.png
const brands_namespaceObject = __webpack_require__.p + "images/brands_9200d8.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/images/brands.png?src-loader&size

/* harmony default export */ const brandssrc_loader_size = ({ src: brands_namespaceObject, aspect: 50.72727272727273, width: 3348, height: 66 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/BrandsRow.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}









var MobileView = function() {
    var _useEntry = _sliced_to_array((0,useEntry/* default */.Z)(), 2), ref = _useEntry[0], entry = _useEntry[1];
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    var imageRef = (0,useScrollingFrame/* default */.Z)({
        horizontalOffset: 16,
        verticalOffset: 16,
        isVisible: isVisible
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: "mt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative overflow-hidden pt-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: imageRef,
                    className: "absolute left-0 top-0 mx-16 w-[1116rem]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread_props(_object_spread({
                        className: "w-full"
                    }, brandssrc_loader_size), {
                        lazy: true
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24 text-center",
                message: messages.text,
                style: "p3"
            })
        ]
    });
};
var BrandsRow = function() {
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: "mt-32 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread_props(_object_spread({
                className: "w-full"
            }, brandssrc_loader_size), {
                lazy: true
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-32",
                message: messages.text,
                style: "p1"
            })
        ]
    });
};
/* harmony default export */ const BrandsRow_BrandsRow = (BrandsRow);


/***/ }),

/***/ 85852:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var compositions_buttons_SubscribeButton_SubscribeButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6658);
/* harmony import */ var compositions_landings_BrandsQualityBlock_BrandsQualityBlock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15743);
/* harmony import */ var _GetStartedButton_GetStartedButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86527);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var BrandsSection = function(props) {
    var className = props.className, startButtonMessage = props.startButtonMessage, customButton = props.customButton;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    var ButtonComponent = (customButton === null || customButton === void 0 ? void 0 : customButton.actionType) === "subscribe" ? compositions_buttons_SubscribeButton_SubscribeButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : _GetStartedButton_GetStartedButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
    var buttonProps = _object_spread({
        title: startButtonMessage,
        size: 56,
        width: isMobile ? null : 280,
        fullWidthOnMobile: true,
        className: isMobile ? "mt-24" : "mt-32"
    }, customButton);
    var button = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonComponent, _object_spread_props(_object_spread({}, buttonProps), {
        placement: "Brand block"
    }));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_landings_BrandsQualityBlock_BrandsQualityBlock__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(className, isMobile && "pb-64"),
        button: button
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(BrandsSection));


/***/ }),

/***/ 86527:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ GetStartedButton_GetStartedButton)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/GetStartedButton/messages.ts
/* harmony default export */ const messages = ({
    quiz: {
        en: "Get started with a quiz"
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/GetStartedButton/GetStartedButton.tsx







var GetStartedButton = function(props) {
    var className = props.className, _props_size = props.size, size = _props_size === void 0 ? 56 : _props_size, _props_style = props.style, style = _props_style === void 0 ? "primary" : _props_style, width = props.width, fullWidth = props.fullWidth, fullWidthOnMobile = props.fullWidthOnMobile, placement = props.placement, title = props.title;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        className: className,
        title: title !== null && title !== void 0 ? title : messages.quiz,
        inlineIcon: isMobile ? "32/arrow-right" : null,
        size: size,
        to: links/* default */.ZP.smartRecommendations,
        style: style,
        width: width,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        html: true,
        onClick: function() {
            (0,analytics/* track */.j)("Banner click", {
                placement: placement,
                content: "Quiz",
                link: links/* default */.ZP.smartRecommendations,
                action: "link"
            });
        },
        "data-testid": "getStartedButton"
    });
};
/* harmony default export */ const GetStartedButton_GetStartedButton = (GetStartedButton);


/***/ }),

/***/ 51564:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeroSection_HeroSection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-helmet-async@2.0.4_react-dom@18.2.0_react@18.2.0/node_modules/react-helmet-async/lib/index.esm.js
var index_esm = __webpack_require__(75479);
// EXTERNAL MODULE: ./local_modules/zina/index.ts
var zina = __webpack_require__(27913);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx + 1 modules
var HeroMediaBlock = __webpack_require__(68155);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image_Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/buttons/SubscribeButton/SubscribeButton.tsx
var SubscribeButton = __webpack_require__(6658);
// EXTERNAL MODULE: ./src/compositions/StyledTimer/StyledTimer.tsx + 1 modules
var StyledTimer = __webpack_require__(93735);
// EXTERNAL MODULE: ./src/pages/landing/View/components/GetStartedButton/GetStartedButton.tsx + 1 modules
var GetStartedButton = __webpack_require__(86527);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/SubscriptionOfferBadge/messages.ts
/* harmony default export */ const messages = ({
    offer: {
        discount: {
            en: "{discount}<br/>off"
        },
        freeTrial: {
            en: "Free<br/>trial"
        },
        free2ndMonth: {
            en: "Second<br/>month<br/>free"
        },
        freeProduct: {
            en: "Free<br/>perfume"
        }
    },
    freeCase: {
        en: "+ a free case"
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/SubscriptionOfferBadge/SubscriptionOfferBadge.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var SubscriptionOfferBadge = function(props) {
    var className = props.className, offerType = props.offerType, discount = props.discount;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var defaultOfferTextSize = isMobile ? "text-[33rem]/[31rem]" : "text-[48rem]/[46rem]";
    var smallOfferTextSize = isMobile ? "text-[19rem]/[20rem]" : "text-[31rem]/[32rem]";
    var offerTextSize = offerType === "discount" || offerType === "freeTrial" ? defaultOfferTextSize : smallOfferTextSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)(className, "absolute rounded-full bg-black font-tt-norms-pro font-bold uppercase", isMobile ? "h-[144rem] w-[144rem] p-6" : "h-[199rem] w-[199rem] p-8"),
        style: {
            background: "linear-gradient(147.02deg, #303030 22.99%, #000000 79.73%)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full items-center justify-center rounded-full border border-pink text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: offerTextSize,
                        message: _object_spread_props(_object_spread({}, messages.offer[offerType]), {
                            values: {
                                discount: discount
                            }
                        }),
                        style: null,
                        color: "gold-30",
                        html: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        className: (0,clsx/* default */.Z)("mt-4", isMobile ? "text-[12rem]/[12rem]" : "text-[16rem]/[16rem]"),
                        message: messages.freeCase,
                        style: null,
                        color: "white",
                        html: true
                    })
                ]
            })
        })
    });
};
/* harmony default export */ const SubscriptionOfferBadge_SubscriptionOfferBadge = (SubscriptionOfferBadge);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/messages.ts
/* harmony default export */ const BottlesAnimationBlock_messages = ({
    productBlock: {
        title: {
            en: "Turn this..."
        },
        subtitle: {
            en: "regular retail price"
        }
    },
    subscriptionBlock: {
        title: {
            en: "Into this"
        },
        subtitle: {
            en: "first month"
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/case.png
const case_namespaceObject = __webpack_require__.p + "images/case_03b104.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/britsheer.png
const britsheer_namespaceObject = __webpack_require__.p + "images/britsheer_313f8f.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/dkny.png
const dkny_namespaceObject = __webpack_require__.p + "images/dkny_5bab6d.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/burberry.png
const burberry_namespaceObject = __webpack_require__.p + "images/burberry_d827cf.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/dg.png
const dg_namespaceObject = __webpack_require__.p + "images/dg_f882a0.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/dg-man.png
const dg_man_namespaceObject = __webpack_require__.p + "images/dg-man_dec035.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/versace.png
const versace_namespaceObject = __webpack_require__.p + "images/versace_b538cf.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/versace-man.png
const versace_man_namespaceObject = __webpack_require__.p + "images/versace-man_94a46c.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/gucci.png
const gucci_namespaceObject = __webpack_require__.p + "images/gucci_2f4ca3.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/juicy.png
const juicy_namespaceObject = __webpack_require__.p + "images/juicy_8b1115.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/images/products/marc.png
const marc_namespaceObject = __webpack_require__.p + "images/marc_95cd4a.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/components/BottlesAnimationBlock/BottlesAnimationBlock.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}























var products = [
    {
        src: dg_namespaceObject,
        price: 46
    },
    {
        src: dkny_namespaceObject,
        price: 80
    },
    {
        src: versace_namespaceObject,
        price: 85
    },
    {
        src: britsheer_namespaceObject,
        price: 95
    },
    {
        src: juicy_namespaceObject,
        price: 106
    },
    {
        src: marc_namespaceObject,
        price: 62
    },
    {
        src: gucci_namespaceObject,
        price: 128
    },
    {
        src: burberry_namespaceObject,
        price: 93
    },
    {
        src: dg_man_namespaceObject,
        price: 82
    },
    {
        src: versace_man_namespaceObject,
        price: 92
    }
];
var imagesCache = [];
var BottlesAnimationBlock = function(props) {
    var className = props.className, offerType = props.offerType, discount = props.discount, subscriptionPrice = props.subscriptionPrice;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useState = _sliced_to_array((0,react.useState)(0), 2), productIndex = _useState[0], setProductIndex = _useState[1];
    // Preload images
    (0,react.useEffect)(function() {
        products.forEach(function(product) {
            var img = new Image();
            img.src = product.src;
            imagesCache.push(img);
        });
    }, []);
    // Change product every interval if the product image is loaded
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            var nextIndex = (productIndex + 1) % products.length;
            var img = imagesCache[nextIndex];
            if (img.complete) {
                setProductIndex(nextIndex);
            } else {
                img.onload = function() {
                    setProductIndex(nextIndex);
                };
            }
        }, 1000);
        return function() {
            clearTimeout(timer);
        };
    }, [
        productIndex
    ]);
    var product = products[productIndex];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "flex items-center", isMobile ? "my-24" : "absolute right-[100rem] top-1/2 -translate-y-1/2"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: isMobile ? "h-[270rem]" : "h-[600rem]",
                        src: product.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: BottlesAnimationBlock_messages.productBlock.title,
                                style: isMobile ? "h9" : "h8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: isMobile ? "mt-4" : "mt-8",
                                message: (0,formatPrice/* default */.Z)(product.price, {
                                    isCents: false,
                                    removeZeroCents: true
                                }),
                                style: isMobile ? "h6" : "h3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: isMobile ? "mt-4" : "mt-8",
                                message: BottlesAnimationBlock_messages.productBlock.subtitle,
                                style: isMobile ? "p6" : "p3"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: isMobile ? "mr-16 !h-12 !w-32" : "mr-64 !h-32 !w-72",
                name: "other/long-arrow-right",
                color: "gold-50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: isMobile ? "h-[270rem]" : "h-[600rem]",
                        src: case_namespaceObject
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: BottlesAnimationBlock_messages.subscriptionBlock.title,
                                style: isMobile ? "h9" : "h8",
                                color: "gold-70"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: isMobile ? "mt-4" : "mt-8",
                                message: subscriptionPrice,
                                style: isMobile ? "h6" : "h3",
                                color: "gold-70"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                className: isMobile ? "mt-4" : "mt-8",
                                message: BottlesAnimationBlock_messages.subscriptionBlock.subtitle,
                                style: isMobile ? "p6" : "p3",
                                color: "gold-70"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionOfferBadge_SubscriptionOfferBadge, {
                        className: (0,clsx/* default */.Z)("absolute", isMobile ? "bottom-96 left-8 scale-[0.6]" : "bottom-[120rem] left-[-108rem] scale-[0.8]"),
                        offerType: offerType,
                        discount: discount
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const BottlesAnimationBlock_BottlesAnimationBlock = (BottlesAnimationBlock);

;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/messages.ts
/* harmony default export */ const HeroSection_messages = ({
    noDiscount: {
        title: {
            en: "Monthly supply of any listed fragrance starting at {price}"
        }
    },
    discount: {
        title: {
            en: 'Indulge in<br class="onlyDesktop"/> new designer scents every month'
        },
        text: {
            en: '\n      Explore a world of fragrance,<br class="onlyDesktop"/> with your<br class="onlyMobile"/>\n      first month priced<br class="onlyDesktop"/> at <s>{price}</s> <b>{priceWithDiscount}</b>.\n      '
        }
    },
    freeTrial: {
        title: {
            en: "Get your free perfume now"
        },
        text: {
            en: "Indulge in new designer scents every month for just {price}. Your first month is free, just pay {extraShippingPrice} for shipping and handling."
        }
    },
    freeProduct: {
        title: {
            en: 'Subscribe and unlock a free product in<br class="onlyDesktop"/> your first<br class="onlyDesktop"/> order'
        },
        text: {
            en: "Indulge in new designer scents every month for just {price}."
        }
    },
    freeMonth: {
        title: {
            en: 'Indulge in<br class="onlyDesktop"/> new designer scents every month'
        },
        text: {
            en: "Buy one, get one free! Monthly supply of any listed fragrance starting at {price}."
        }
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/desktop-hero.jpg
const desktop_hero_namespaceObject = __webpack_require__.p + "images/desktop-hero_a4e0fb.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/desktop-hero.jpg?src-loader&size

/* harmony default export */ const desktop_herosrc_loader_size = ({ src: desktop_hero_namespaceObject, aspect: 1.875, width: 2880, height: 1536 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero.jpg
const mobile_hero_namespaceObject = __webpack_require__.p + "images/mobile-hero_58e47b.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero.jpg?src-loader&size

/* harmony default export */ const mobile_herosrc_loader_size = ({ src: mobile_hero_namespaceObject, aspect: 0.5473684210526316, width: 832, height: 1520 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/desktop-hero-ab.jpg
const desktop_hero_ab_namespaceObject = __webpack_require__.p + "images/desktop-hero-ab_f9074c.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/desktop-hero-ab.jpg?src-loader&size

/* harmony default export */ const desktop_hero_absrc_loader_size = ({ src: desktop_hero_ab_namespaceObject, aspect: 1.875, width: 2880, height: 1536 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero-ab.jpg
const mobile_hero_ab_namespaceObject = __webpack_require__.p + "images/mobile-hero-ab_8768ae.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero-ab.jpg?src-loader&size

/* harmony default export */ const mobile_hero_absrc_loader_size = ({ src: mobile_hero_ab_namespaceObject, aspect: 0.5340179717586649, width: 832, height: 1558 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero-with-case.jpg
const mobile_hero_with_case_namespaceObject = __webpack_require__.p + "images/mobile-hero-with-case_de858a.jpg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/images/mobile-hero-with-case.jpg?src-loader&size

/* harmony default export */ const mobile_hero_with_casesrc_loader_size = ({ src: mobile_hero_with_case_namespaceObject, aspect: 0.6135693215339233, width: 832, height: 1356 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/HeroSection/HeroSection.tsx
function HeroSection_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeroSection_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeroSection_define_property(target, key, source[key]);
        });
    }
    return target;
}
function HeroSection_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HeroSection_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HeroSection_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



























var messagesByOffer = {
    freeTrial: HeroSection_messages.freeTrial,
    free2ndMonth: HeroSection_messages.freeMonth,
    freeProduct: HeroSection_messages.freeProduct,
    discount: HeroSection_messages.discount
};
var HeroSection = function(props) {
    var _customBlocks_timer, _customBlocks_timer1, _customBlocks_timer2, _customBlocks_timer3, _customBlocks_timer4, _customBlocks_timer5, _customBlocks_timer6, _customBlocks_timer7, _customBlocks_timer8, _customBlocks_preTitle, _customBlocks_title, _customBlocks_text, _customBlocks_note, _customBlocks_afterButtonText, _customBlocks_preTitle1, _customBlocks_title1, _customBlocks_text1, _customBlocks_note1, _customBlocks_afterButtonText1, _customBlocks_preTitle2, _customBlocks_title2, _customBlocks_text2, _customBlocks_note2, _customBlocks_afterButtonText2, _customBlocks_button;
    var customBlocks = props.customBlocks, discount = props.discount, extraShippingPrice = props.extraShippingPrice, isFetching = props.isFetching, offerType = props.offerType, price = props.price, priceWithDiscount = props.priceWithDiscount, isTimerEnabled = props.isTimerEnabled, startButtonMessage = props.startButtonMessage, offerBadge = props.offerBadge;
    var _useDevice = (0,useDevice/* default */.Z)(), isMobile = _useDevice.isMobile, isDesktop = _useDevice.isDesktop;
    var pathname = (0,contexts/* usePathname */.jD)();
    var withOfferBadge = offerType && pathname !== links/* default */.ZP.nift;
    var isBottlesTextAnimationAbEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.homeHeroBottlesTextAnimation) === "b";
    var isBottlesTextAnimationVisible = isBottlesTextAnimationAbEnabled && withOfferBadge && !customBlocks;
    var withTimer = Boolean(offerType && isTimerEnabled);
    var heroImage;
    if (customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.background) {
        heroImage = customBlocks.background;
    } else {
        if (isMobile) {
            if (withOfferBadge) {
                heroImage = isBottlesTextAnimationAbEnabled ? mobile_hero_absrc_loader_size : mobile_hero_with_casesrc_loader_size;
            } else {
                heroImage = mobile_herosrc_loader_size;
            }
        } else {
            heroImage = isBottlesTextAnimationVisible ? desktop_hero_absrc_loader_size : desktop_herosrc_loader_size;
        }
    }
    var preTitle;
    var titleMessage;
    var textMessage;
    var noteMessage;
    var afterButtonText;
    if (customBlocks) {
        var _customBlocks_preTitle3, _customBlocks_title3, _customBlocks_text3, _customBlocks_note3, _customBlocks_afterButtonText3;
        preTitle = (_customBlocks_preTitle3 = customBlocks.preTitle) === null || _customBlocks_preTitle3 === void 0 ? void 0 : _customBlocks_preTitle3.message;
        titleMessage = (_customBlocks_title3 = customBlocks.title) === null || _customBlocks_title3 === void 0 ? void 0 : _customBlocks_title3.message;
        if ((_customBlocks_text3 = customBlocks.text) === null || _customBlocks_text3 === void 0 ? void 0 : _customBlocks_text3.message) {
            var _customBlocks_text4, _customBlocks_text5, _customBlocks_text6, _customBlocks_text7;
            textMessage = typeof ((_customBlocks_text4 = customBlocks.text) === null || _customBlocks_text4 === void 0 ? void 0 : _customBlocks_text4.message) === "string" ? (_customBlocks_text5 = customBlocks.text) === null || _customBlocks_text5 === void 0 ? void 0 : _customBlocks_text5.message : HeroSection_object_spread_props(HeroSection_object_spread({}, (_customBlocks_text6 = customBlocks.text) === null || _customBlocks_text6 === void 0 ? void 0 : _customBlocks_text6.message), {
                values: HeroSection_object_spread({
                    price: price,
                    priceWithDiscount: priceWithDiscount
                }, (_customBlocks_text7 = customBlocks.text) === null || _customBlocks_text7 === void 0 ? void 0 : _customBlocks_text7.message.values)
            });
        }
        noteMessage = (_customBlocks_note3 = customBlocks.note) === null || _customBlocks_note3 === void 0 ? void 0 : _customBlocks_note3.message;
        afterButtonText = (_customBlocks_afterButtonText3 = customBlocks.afterButtonText) === null || _customBlocks_afterButtonText3 === void 0 ? void 0 : _customBlocks_afterButtonText3.message;
    } else {
        var _messagesByOffer_offerType, _messagesByOffer_offerType1, _messagesByOffer_offerType2;
        titleMessage = HeroSection_object_spread_props(HeroSection_object_spread({}, ((_messagesByOffer_offerType = messagesByOffer[offerType]) === null || _messagesByOffer_offerType === void 0 ? void 0 : _messagesByOffer_offerType.title) || HeroSection_messages.noDiscount.title), {
            values: {
                discount: discount,
                price: price
            }
        });
        if ((_messagesByOffer_offerType1 = messagesByOffer[offerType]) === null || _messagesByOffer_offerType1 === void 0 ? void 0 : _messagesByOffer_offerType1.text) {
            var _messagesByOffer_offerType3;
            textMessage = HeroSection_object_spread_props(HeroSection_object_spread({}, (_messagesByOffer_offerType3 = messagesByOffer[offerType]) === null || _messagesByOffer_offerType3 === void 0 ? void 0 : _messagesByOffer_offerType3.text), {
                values: {
                    price: price,
                    extraShippingPrice: extraShippingPrice,
                    priceWithDiscount: priceWithDiscount || price
                }
            });
        }
        if ((_messagesByOffer_offerType2 = messagesByOffer[offerType]) === null || _messagesByOffer_offerType2 === void 0 ? void 0 : _messagesByOffer_offerType2.note) {
            var _messagesByOffer_offerType4;
            noteMessage = HeroSection_object_spread_props(HeroSection_object_spread({}, (_messagesByOffer_offerType4 = messagesByOffer[offerType]) === null || _messagesByOffer_offerType4 === void 0 ? void 0 : _messagesByOffer_offerType4.note), {
                values: {
                    priceWithDiscount: priceWithDiscount || price,
                    withBr: !withTimer
                }
            });
        }
    }
    var withLogo = Boolean(customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.logo);
    var isTimerWithLabel = (customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.timer) === undefined || (customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer = customBlocks.timer) === null || _customBlocks_timer === void 0 ? void 0 : _customBlocks_timer.withLabel);
    var _customBlocks_timer_className;
    var timerClassName = (_customBlocks_timer_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer1 = customBlocks.timer) === null || _customBlocks_timer1 === void 0 ? void 0 : _customBlocks_timer1.className) !== null && _customBlocks_timer_className !== void 0 ? _customBlocks_timer_className : !noteMessage || !isTimerWithLabel ? "mt-24" : null;
    var _customBlocks_timer_backgroundColor;
    var timerBackgroundColor = ((_customBlocks_timer_backgroundColor = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer2 = customBlocks.timer) === null || _customBlocks_timer2 === void 0 ? void 0 : _customBlocks_timer2.backgroundColor) !== null && _customBlocks_timer_backgroundColor !== void 0 ? _customBlocks_timer_backgroundColor : isBottlesTextAnimationVisible) ? "gold-70" : undefined;
    var _customBlocks_timer_countdownColor;
    var timerCountdownColor = ((_customBlocks_timer_countdownColor = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer3 = customBlocks.timer) === null || _customBlocks_timer3 === void 0 ? void 0 : _customBlocks_timer3.countdownColor) !== null && _customBlocks_timer_countdownColor !== void 0 ? _customBlocks_timer_countdownColor : isBottlesTextAnimationVisible) ? "white" : undefined;
    var _customBlocks_timer_captionColor;
    var timerCaptionColor = (_customBlocks_timer_captionColor = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer4 = customBlocks.timer) === null || _customBlocks_timer4 === void 0 ? void 0 : _customBlocks_timer4.captionColor) !== null && _customBlocks_timer_captionColor !== void 0 ? _customBlocks_timer_captionColor : undefined;
    var _customBlocks_timer_size;
    var timerSize = (_customBlocks_timer_size = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer5 = customBlocks.timer) === null || _customBlocks_timer5 === void 0 ? void 0 : _customBlocks_timer5.size) !== null && _customBlocks_timer_size !== void 0 ? _customBlocks_timer_size : 56;
    var _customBlocks_timer_titleClassname;
    var timerTitleClassname = (_customBlocks_timer_titleClassname = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer6 = customBlocks.timer) === null || _customBlocks_timer6 === void 0 ? void 0 : _customBlocks_timer6.titleClassname) !== null && _customBlocks_timer_titleClassname !== void 0 ? _customBlocks_timer_titleClassname : "mb-12";
    var _customBlocks_timer_titleStyle;
    var timerTitleStyle = (_customBlocks_timer_titleStyle = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer7 = customBlocks.timer) === null || _customBlocks_timer7 === void 0 ? void 0 : _customBlocks_timer7.titleStyle) !== null && _customBlocks_timer_titleStyle !== void 0 ? _customBlocks_timer_titleStyle : isMobile ? "p5" : "p1";
    var _customBlocks_timer_titleColor;
    var timerTitleColor = (_customBlocks_timer_titleColor = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_timer8 = customBlocks.timer) === null || _customBlocks_timer8 === void 0 ? void 0 : _customBlocks_timer8.titleColor) !== null && _customBlocks_timer_titleColor !== void 0 ? _customBlocks_timer_titleColor : "black";
    var _customBlocks_preTitle_style;
    var preTitleStyle = (_customBlocks_preTitle_style = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_preTitle = customBlocks.preTitle) === null || _customBlocks_preTitle === void 0 ? void 0 : _customBlocks_preTitle.style) !== null && _customBlocks_preTitle_style !== void 0 ? _customBlocks_preTitle_style : isMobile ? "p1" : "sh3";
    var _customBlocks_title_style;
    var titleStyle = (_customBlocks_title_style = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_title = customBlocks.title) === null || _customBlocks_title === void 0 ? void 0 : _customBlocks_title.style) !== null && _customBlocks_title_style !== void 0 ? _customBlocks_title_style : isMobile ? "h3" : "h2";
    var _customBlocks_text_style;
    var textStyle = (_customBlocks_text_style = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_text = customBlocks.text) === null || _customBlocks_text === void 0 ? void 0 : _customBlocks_text.style) !== null && _customBlocks_text_style !== void 0 ? _customBlocks_text_style : isMobile ? "p1" : "sh3";
    var _customBlocks_note_style;
    var noteStyle = (_customBlocks_note_style = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_note = customBlocks.note) === null || _customBlocks_note === void 0 ? void 0 : _customBlocks_note.style) !== null && _customBlocks_note_style !== void 0 ? _customBlocks_note_style : isMobile ? "t1" : "sh3";
    var _customBlocks_afterButtonText_style;
    var afterButtonTextStyle = (_customBlocks_afterButtonText_style = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_afterButtonText = customBlocks.afterButtonText) === null || _customBlocks_afterButtonText === void 0 ? void 0 : _customBlocks_afterButtonText.style) !== null && _customBlocks_afterButtonText_style !== void 0 ? _customBlocks_afterButtonText_style : "sh6";
    var _customBlocks_preTitle_color;
    var preTitleColor = (_customBlocks_preTitle_color = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_preTitle1 = customBlocks.preTitle) === null || _customBlocks_preTitle1 === void 0 ? void 0 : _customBlocks_preTitle1.color) !== null && _customBlocks_preTitle_color !== void 0 ? _customBlocks_preTitle_color : undefined;
    var _customBlocks_title_color;
    var titleColor = (_customBlocks_title_color = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_title1 = customBlocks.title) === null || _customBlocks_title1 === void 0 ? void 0 : _customBlocks_title1.color) !== null && _customBlocks_title_color !== void 0 ? _customBlocks_title_color : undefined;
    var _customBlocks_text_color;
    var textColor = (_customBlocks_text_color = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_text1 = customBlocks.text) === null || _customBlocks_text1 === void 0 ? void 0 : _customBlocks_text1.color) !== null && _customBlocks_text_color !== void 0 ? _customBlocks_text_color : undefined;
    var _customBlocks_note_color;
    var noteColor = (_customBlocks_note_color = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_note1 = customBlocks.note) === null || _customBlocks_note1 === void 0 ? void 0 : _customBlocks_note1.color) !== null && _customBlocks_note_color !== void 0 ? _customBlocks_note_color : "white";
    var _customBlocks_afterButtonText_color;
    var afterButtonTextColor = (_customBlocks_afterButtonText_color = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_afterButtonText1 = customBlocks.afterButtonText) === null || _customBlocks_afterButtonText1 === void 0 ? void 0 : _customBlocks_afterButtonText1.color) !== null && _customBlocks_afterButtonText_color !== void 0 ? _customBlocks_afterButtonText_color : undefined;
    var _customBlocks_preTitle_className;
    var preTitleClassname = (_customBlocks_preTitle_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_preTitle2 = customBlocks.preTitle) === null || _customBlocks_preTitle2 === void 0 ? void 0 : _customBlocks_preTitle2.className) !== null && _customBlocks_preTitle_className !== void 0 ? _customBlocks_preTitle_className : "mb-20 text-white";
    var _customBlocks_title_className;
    var titleClassname = (_customBlocks_title_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_title2 = customBlocks.title) === null || _customBlocks_title2 === void 0 ? void 0 : _customBlocks_title2.className) !== null && _customBlocks_title_className !== void 0 ? _customBlocks_title_className : "max-w-464";
    var _customBlocks_text_className;
    var textClassname = (_customBlocks_text_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_text2 = customBlocks.text) === null || _customBlocks_text2 === void 0 ? void 0 : _customBlocks_text2.className) !== null && _customBlocks_text_className !== void 0 ? _customBlocks_text_className : isMobile ? "mt-8" : "mt-24 max-w-464 pr-64";
    var _customBlocks_note_className;
    var noteClassname = (_customBlocks_note_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_note2 = customBlocks.note) === null || _customBlocks_note2 === void 0 ? void 0 : _customBlocks_note2.className) !== null && _customBlocks_note_className !== void 0 ? _customBlocks_note_className : isMobile ? "mt-8" : (0,clsx/* default */.Z)("mt-16 max-w-464 pr-64", withTimer ? "whitespace-nowrap" : "whitespace-pre-line");
    var _customBlocks_afterButtonText_className;
    var afterButtonTextClassname = (_customBlocks_afterButtonText_className = customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_afterButtonText2 = customBlocks.afterButtonText) === null || _customBlocks_afterButtonText2 === void 0 ? void 0 : _customBlocks_afterButtonText2.className) !== null && _customBlocks_afterButtonText_className !== void 0 ? _customBlocks_afterButtonText_className : isMobile ? "mt-8" : "mt-20";
    var ButtonComponent = (customBlocks === null || customBlocks === void 0 ? void 0 : (_customBlocks_button = customBlocks.button) === null || _customBlocks_button === void 0 ? void 0 : _customBlocks_button.actionType) === "subscribe" ? SubscribeButton/* default */.Z : GetStartedButton/* default */.Z;
    var buttonProps = HeroSection_object_spread({
        title: startButtonMessage,
        size: 56,
        width: 280,
        className: withTimer ? "mt-32" : "mt-56"
    }, customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.button);
    var mobileMinHeight;
    if (withLogo) {
        mobileMinHeight = "760rem";
    } else if (withTimer) {
        mobileMinHeight = "686rem";
    } else {
        mobileMinHeight = "608rem";
    }
    // inline without zina to improve page load speed (LCP)
    var heroImageSrc = (0,zina/* useZinaStaticImage */.uN)({
        src: heroImage.src
    });
    var style = {
        background: "url(".concat(heroImageSrc, ")"),
        backgroundPosition: isMobile ? "bottom" : undefined,
        backgroundSize: "cover",
        minHeight: isMobile ? mobileMinHeight : "768rem",
        backgroundRepeat: "no-repeat"
    };
    var containerClassName = isMobile ? "flex w-full bg-gold-30 pt-24 text-center" : "flex w-full items-center justify-start bg-gold-30";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroMediaBlock/* default */.Z, {
        className: "relative overflow-hidden",
        "data-testid": "heroSection",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Helmet */.ql, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: heroImageSrc,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: containerClassName,
                style: style,
                children: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                    className: isMobile ? null : "w-full max-w-464",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                            className: (0,clsx/* default */.Z)("w-full max-w-336 rounded", isMobile && "mx-auto"),
                            h: isMobile ? 20 : 40,
                            bgColor: "gray-70"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                            className: (0,clsx/* default */.Z)("mt-12 rounded", isMobile && "mx-auto"),
                            w: isMobile ? 200 : 400,
                            h: isMobile ? 20 : 40,
                            bgColor: "gray-70"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                            className: (0,clsx/* default */.Z)(isMobile ? "mx-auto mt-16" : "mt-32"),
                            w: isMobile ? 240 : 280,
                            h: isMobile ? 38 : 56,
                            bgColor: "gray-70"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
                    ignore: isMobile,
                    className: (0,clsx/* default */.Z)("w-full", isMobile && "flex flex-col px-16"),
                    children: [
                        withLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image/* default */.Z, {
                            className: isMobile ? "mb-16 max-h-80 self-center" : "mb-24 max-h-[110rem]",
                            src: customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.logo
                        }),
                        Boolean(preTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: preTitleClassname,
                            message: preTitle,
                            style: preTitleStyle,
                            color: preTitleColor,
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: titleClassname,
                            message: titleMessage,
                            style: titleStyle,
                            color: titleColor,
                            html: true
                        }),
                        Boolean(textMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: textClassname,
                            message: textMessage,
                            style: textStyle,
                            color: textColor,
                            html: true
                        }),
                        Boolean(noteMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: noteClassname,
                            message: noteMessage,
                            style: noteStyle,
                            color: noteColor,
                            html: true
                        }),
                        withTimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTimer/* default */.Z, {
                            className: timerClassName,
                            size: timerSize,
                            backgroundColor: timerBackgroundColor,
                            countdownColor: timerCountdownColor,
                            captionColor: timerCaptionColor,
                            withTitle: isTimerWithLabel,
                            titleClassname: timerTitleClassname,
                            titleStyle: timerTitleStyle,
                            titleColor: timerTitleColor,
                            "data-testid": "timer"
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, HeroSection_object_spread_props(HeroSection_object_spread({}, buttonProps), {
                            placement: "Hero banner"
                        })),
                        Boolean(afterButtonText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: afterButtonTextClassname,
                            message: afterButtonText,
                            style: afterButtonTextStyle,
                            color: afterButtonTextColor,
                            html: true
                        }),
                        withOfferBadge && !offerBadge && !isBottlesTextAnimationVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionOfferBadge_SubscriptionOfferBadge, {
                            className: (0,clsx/* default */.Z)("absolute", isMobile ? "bottom-16 right-12" : "bottom-88 left-[690rem]"),
                            offerType: offerType,
                            discount: discount
                        }),
                        offerBadge,
                        isBottlesTextAnimationVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BottlesAnimationBlock_BottlesAnimationBlock, {
                                    offerType: offerType,
                                    discount: discount,
                                    subscriptionPrice: offerType === "discount" ? priceWithDiscount : price
                                }),
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonComponent, {
                                    className: "mb-16",
                                    title: startButtonMessage,
                                    size: 56,
                                    fullWidthOnMobile: true,
                                    placement: "Hero banner"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ const HeroSection_HeroSection = (/*#__PURE__*/react.memo(HeroSection));


/***/ }),

/***/ 73951:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ PressSection_PressSection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 1 modules
var Image = __webpack_require__(85808);
// EXTERNAL MODULE: ./src/compositions/blocks/QuoteBlock/QuoteBlock.tsx
var QuoteBlock = __webpack_require__(27344);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/messages.ts
/* harmony default export */ const messages = ({
    asFeatured: {
        en: "As featured in"
    },
    featuredQuote: {
        en: "Scent-sational monthly subscription box that delivers a new perfume to your doorstep each month."
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/glamour.svg
const glamour_namespaceObject = __webpack_require__.p + "images-svg/glamour_65af54.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/glamour.svg?src-loader&size

/* harmony default export */ const glamoursrc_loader_size = ({ src: glamour_namespaceObject, aspect: 4, width: 168, height: 42 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/vogue.svg
const vogue_namespaceObject = __webpack_require__.p + "images-svg/vogue_a864f0.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/vogue.svg?src-loader&size

/* harmony default export */ const voguesrc_loader_size = ({ src: vogue_namespaceObject, aspect: 3.7037037037037037, width: 100, height: 27 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/gq.svg
const gq_namespaceObject = __webpack_require__.p + "images-svg/gq_fe6060.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/gq.svg?src-loader&size

/* harmony default export */ const gqsrc_loader_size = ({ src: gq_namespaceObject, aspect: 1.8484848484848484, width: 61, height: 33 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/esquire.svg
const esquire_namespaceObject = __webpack_require__.p + "images-svg/esquire_5388d4.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/esquire.svg?src-loader&size

/* harmony default export */ const esquiresrc_loader_size = ({ src: esquire_namespaceObject, aspect: 6.315789473684211, width: 120, height: 19 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/buzzfeed.svg
const buzzfeed_namespaceObject = __webpack_require__.p + "images-svg/buzzfeed_52c33d.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/buzzfeed.svg?src-loader&size

/* harmony default export */ const buzzfeedsrc_loader_size = ({ src: buzzfeed_namespaceObject, aspect: 5.2631578947368425, width: 100, height: 19 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/instyle.svg
const instyle_namespaceObject = __webpack_require__.p + "images-svg/instyle_336400.svg";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/images/instyle.svg?src-loader&size

/* harmony default export */ const instylesrc_loader_size = ({ src: instyle_namespaceObject, aspect: 4.25531914893617, width: 200, height: 47 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/PressSection/PressSection.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var authorImage = _object_spread_props(_object_spread({
    className: "w-[168rem]"
}, glamoursrc_loader_size), {
    alt: "Glamour",
    lazy: true
});
var otherPressImages = [
    _object_spread_props(_object_spread({
        className: "w-[100rem]"
    }, voguesrc_loader_size), {
        alt: "Vogue"
    }),
    _object_spread_props(_object_spread({
        className: "w-[60rem]"
    }, gqsrc_loader_size), {
        alt: "GQ"
    }),
    _object_spread_props(_object_spread({
        className: "w-[120rem]"
    }, esquiresrc_loader_size), {
        alt: "Esquire"
    }),
    _object_spread_props(_object_spread({
        className: "w-[100rem]"
    }, buzzfeedsrc_loader_size), {
        alt: "BuzzFeed"
    }),
    _object_spread_props(_object_spread({
        className: "w-[100rem]"
    }, instylesrc_loader_size), {
        alt: "inStyle"
    })
];
var PressSection = function(param) {
    var className = param.className;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var otherImages = isMobile ? otherPressImages.slice(0, 3) : otherPressImages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: className,
                message: messages.asFeatured,
                style: "h6",
                color: "gold-50",
                align: "center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuoteBlock/* default */.Z, {
                className: "mt-32",
                text: messages.featuredQuote,
                authorImage: authorImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)("mx-auto mt-24 flex max-w-752 justify-between", isMobile ? "px-36" : "px-24"),
                children: otherImages.map(function(imageProps) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _object_spread_props(_object_spread({}, imageProps), {
                        lazy: true
                    }), imageProps.alt);
                })
            })
        ]
    });
};
/* harmony default export */ const PressSection_PressSection = (PressSection);


/***/ }),

/***/ 48266:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductsSection_ProductsSection)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/containers/ProductsInQueueProvider/ProductsInQueueProvider.tsx
var ProductsInQueueProvider = __webpack_require__(36122);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(4130);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/modules/products/useProducts.ts + 1 modules
var useProducts = __webpack_require__(55429);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/layout/Bone/Bone.tsx + 1 modules
var Bone = __webpack_require__(10430);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(73095);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailedSkeleton/ProductCardDetailedSkeleton.tsx
var ProductCardDetailedSkeleton = __webpack_require__(1511);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(80759);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardDetailed/ProductCardDetailed.tsx
var ProductCardDetailed = __webpack_require__(55493);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/ProductsFeedSection/ProductsFeedSection.tsx













var ProductsFeedSection = function(props) {
    var className = props.className, title = props.title, slugs = props.slugs, withoutLink = props.withoutLink, withRetailPrice = props.withRetailPrice, excludeLabels = props.excludeLabels, buttonProps = props.buttonProps;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useProducts = (0,useProducts/* default */.Z)({
        variables: {
            input: {
                slugs: slugs,
                visibility: [
                    "LANDING",
                    "VISIBLE"
                ]
            },
            isDrift: true
        }
    }), isFetching = _useProducts.isFetching, _useProducts_products = _useProducts.products, products = _useProducts_products === void 0 ? [] : _useProducts_products;
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bone/* default */.Z, {
                    pw: 100,
                    h: 37,
                    bgColor: "light-beige"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)("mt-24 grid grid-flow-dense items-stretch gap-16", isMobile ? "grid-cols-2" : "grid-cols-3"),
                    children: Array(isMobile ? 2 : 3).fill(0).map(function(_, index) {
                        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardDetailedSkeleton/* default */.Z, {}, index);
                    })
                })
            ]
        });
    }
    var productsContainerClassName = (0,clsx/* default */.Z)(className, "mt-24 grid grid-flow-dense items-stretch gap-16", isMobile ? "grid-cols-2-center" : "grid-cols-3-center");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: isMobile ? "mb-32 mt-64" : "mb-40 mt-80",
                message: title,
                style: isMobile ? "h4" : "h3",
                html: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: productsContainerClassName,
                role: "list",
                children: Boolean(products === null || products === void 0 ? void 0 : products.length) && products.map(function(data) {
                    return /*#__PURE__*/ react.createElement(isMobile ? ProductCardSmall/* default */.Z : ProductCardDetailed/* default */.Z, {
                        key: data.id,
                        data: data,
                        withoutLink: withoutLink,
                        replaceRatingWithRetailPrice: withRetailPrice,
                        buttonProps: buttonProps,
                        excludeLabels: excludeLabels
                    });
                })
            })
        ]
    });
};
/* harmony default export */ const ProductsFeedSection_ProductsFeedSection = (ProductsFeedSection);

// EXTERNAL MODULE: ./src/compositions/landings/BestsellersBlock/BestsellersBlock.tsx + 1 modules
var BestsellersBlock = __webpack_require__(92268);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BestsellersSection/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: 'Select what you\'d like to try <br class="onlyDesktop" />from our best sellers'
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/BestsellersSection/BestsellersSection.tsx




var BestsellersSection = function(props) {
    var className = props.className, title = props.title, buttonProps = props.buttonProps, fetchMoreButtonTitle = props.fetchMoreButtonTitle, fetchMoreButtonStyle = props.fetchMoreButtonStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellersBlock/* default */.Z, {
        id: "products",
        className: className,
        title: title || messages.title,
        withRetailPrice: true,
        buttonProps: buttonProps,
        fetchMoreButtonTitle: fetchMoreButtonTitle,
        fetchMoreButtonStyle: fetchMoreButtonStyle
    });
};
/* harmony default export */ const BestsellersSection_BestsellersSection = (/*#__PURE__*/react.memo(BestsellersSection));

;// CONCATENATED MODULE: ./src/pages/landing/View/components/ProductsSection/ProductsSection.tsx





var ProductsSection = function(props) {
    var className = props.className, customProducts = props.customProducts, fetchMoreButtonTitle = props.fetchMoreButtonTitle, fetchMoreButtonStyle = props.fetchMoreButtonStyle;
    var updateCount = (0,ProductsInQueueProvider/* useProductsInQueueContext */.X)().updateCount;
    var buttonProps = {
        withNotification: false,
        withNonAuthRedirect: false,
        withErrorModals: false,
        force: true,
        metadata: {
            placement: "Bestsellers"
        },
        onClick: updateCount
    };
    if (customProducts === null || customProducts === void 0 ? void 0 : customProducts.slugs) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsFeedSection_ProductsFeedSection, {
            className: className,
            title: customProducts.title,
            slugs: customProducts.slugs,
            withoutLink: customProducts.withoutLink,
            withRetailPrice: customProducts.withRetailPrice,
            excludeLabels: customProducts.excludeLabels,
            buttonProps: buttonProps
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellersSection_BestsellersSection, {
        className: className,
        title: customProducts === null || customProducts === void 0 ? void 0 : customProducts.title,
        buttonProps: buttonProps,
        fetchMoreButtonTitle: fetchMoreButtonTitle,
        fetchMoreButtonStyle: fetchMoreButtonStyle
    });
};
/* harmony default export */ const ProductsSection_ProductsSection = (/*#__PURE__*/react.memo(ProductsSection));


/***/ }),

/***/ 72757:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98716);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47361);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17382);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98669);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68155);









var QuizEditorialBanner = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "compositions-banners-QuizEditorialBanner-QuizEditorialBanner";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | compositions-banners-QuizEditorialBanner-QuizEditorialBanner */ 4864).then(__webpack_require__.bind(__webpack_require__, 30687));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(30687);
        }
        return eval("require.resolve")("compositions/banners/QuizEditorialBanner/QuizEditorialBanner");
    }
}, {
    fallback: (0,components_layout__WEBPACK_IMPORTED_MODULE_5__/* .createFallback */ .rU)({
        h: 680
    })
});
var QuizSection = function(param) {
    var className = param.className;
    var _user_analyticsMetadata;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().isMobile;
    var user = (0,modules_user__WEBPACK_IMPORTED_MODULE_7__/* .useUser */ .a)().user;
    var hasScentProfile = Boolean(user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.hasScentProfile);
    if (isMobile) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(QuizEditorialBanner, {
            className: className,
            withScentProfile: hasScentProfile,
            withButtonTitleArrow: !hasScentProfile
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: className,
        wideMT: false,
        wideMB: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(QuizEditorialBanner, {
            withScentProfile: hasScentProfile
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuizSection);


/***/ }),

/***/ 33748:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    getStartedForPrice: {
        en: "Try first month for {price}"
    },
    getStartedForOriginalPriceCrossed: {
        en: "Try first month for {priceWithDiscount} <s>{price}</s>"
    },
    getStartedForPriceCrossedGold: {
        en: 'Try first month for <span class="text-gold-30">{priceWithDiscount}</span> <s>{price}</s>'
    },
    selectBlockTitle: {
        en: "Exclusive access for scentbird subscribers"
    },
    selectBlockDescription: {
        en: '\n    Discover our curated collection of premium perfumes and colognes from the most exclusive fragrance houses,<br class="onlyDesktop"/> hand-picked by our team of scent experts.\n    Receive a black atomizer with every Scentbird Select scent.\n    '
    }
});


/***/ })

}]);